import React from 'react';

type SpaceImageIconProps = {
  mode?: 'light' | 'dark';
};

const SpaceImageIcon = ({ mode = 'light' }: SpaceImageIconProps) => {
  const color = mode === 'dark' ? 'white' : 'black';
  const iconOpacity = mode === 'dark' ? 1 : 0.87;

  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
      <rect width="36" height="36" rx="18" fill={color} fillOpacity="0.12" />
      <path
        d="M25.4997 10.5H10.4997C9.66634 10.5 8.83301 11.3333 8.83301 12.1667V23.8333C8.83301 24.75 9.58301 25.5 10.4997 25.5H25.4997C26.333 25.5 27.1663 24.6667 27.1663 23.8333V12.1667C27.1663 11.3333 26.333 10.5 25.4997 10.5ZM25.4997 23.7667C25.483 23.7917 25.4497 23.8167 25.433 23.8333H10.4997V12.2333L10.5663 12.1667H25.4247C25.4497 12.1833 25.4747 12.2167 25.4913 12.2333V23.7667H25.4997ZM17.1663 20.925L15.083 18.4167L12.1663 22.1667H23.833L20.083 17.1667L17.1663 20.925Z"
        fill={color}
        fillOpacity={iconOpacity}
      />
    </svg>
  );
};

export default SpaceImageIcon;
